import { render, staticRenderFns } from "./ErrorMsg.vue?vue&type=template&id=e6ec66f8&scoped=true"
import script from "./ErrorMsg.vue?vue&type=script&lang=js"
export * from "./ErrorMsg.vue?vue&type=script&lang=js"
import style0 from "./ErrorMsg.vue?vue&type=style&index=0&id=e6ec66f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ec66f8",
  null
  
)

export default component.exports